import { APP_NAMES } from '../routes/academyRoutes';
export const getAppName = () => {
  var _window$hubspot$bende, _window;
  // @ts-ignore - No bender type in the hubspot window object yet
  return (_window$hubspot$bende = (_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 || (_window = _window.bender) === null || _window === void 0 ? void 0 : _window.currentProject) !== null && _window$hubspot$bende !== void 0 ? _window$hubspot$bende : undefined;
};
export const getAppVersion = () => {
  var _window2;
  // @ts-ignore - No bender type in the hubspot window object yet
  const currentProjectVersion = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.hubspot) === null || _window2 === void 0 || (_window2 = _window2.bender) === null || _window2 === void 0 ? void 0 : _window2.currentProjectVersion;
  if (!currentProjectVersion || typeof currentProjectVersion !== 'string') {
    return undefined;
  }
  return currentProjectVersion.replace(/^static-?/, '') || 'dev';
};
export const isRecognizedAppName = name => {
  return APP_NAMES.includes(name);
};